var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"bjzc-service"}},[_c('PageHeading',[_vm._v(_vm._s(_vm.$t('service.name')))]),_c('div',{staticClass:"bjzc-page-content"},[_c('ServiceList')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }